'use client';

import { createContext } from 'react';

import type { AssistChipContextInterface } from '../types/assist-chip-root.types';

export const AssistChipContext = createContext<AssistChipContextInterface>({});

AssistChipContext.displayName = 'AssistChip.Context';
